module.exports = __webpack_public_path__ + "static/img/large-screen-bg.de2669c5.png";